export enum ServiceType {
  Mail = 0,
  Drive = 1,
  Contacts = 2,
  Calendar = 3,
  SharePoint = 4,
  TeamDrives = 5,
  Users = 6,
  PublicFolder = 7,
  Export = 8,
  PersonalSite = 9,
  PublicFolderMail = 10,
  PublicFolderCalendar = 11,
  PublicFolderContact = 12,
  Teams = 13,
  CalculateProviderSize = 14,
  Payments = 15,
  History = 16,
  All = 255
}
